<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-toolbar v-if="!disabled">
        <template v-slot:buttons>
          <vxe-button @click="productNameClick()" >添加产品</vxe-button>
          <vxe-button @click="deleteTable()">清空</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table :data="productList">
        <vxe-table-column min-width="100" field="productCode" title="产品编码">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="productName" title="产品名称">
        </vxe-table-column>
        <vxe-table-column
          title="操作"
          width="100"
          show-overflow
          v-if="!disabled"
          key="操作"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="deletRow(row, rowIndex)">删除</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'configProducts',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    disabled: Boolean,
    getValue: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    value: {
      handler(val) {
        this.productList = val || [];
      },
      deep: true,
    },
    disabled(val) {
      console.log('🚀 ~ disabled ~ val:', val);
    },
  },
  data() {
    return {
      productList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.productList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.productList, 'productList');
        this.productList.splice(rowIndex, 1);
        this.$emit('input', this.productList);
      });
    },
    deleteTable() {
      this.productList = [];
      this.$emit('input', []);
    },
    // 打开点击弹窗产品名称
    productNameClick(index) {
      const proxL = this.getValue('productLevelCode');
      console.log(proxL);
      if (!proxL) {
        this.$message.warning('请先选择产品系列');
        return;
      }
      const params = {
        data: this.productList,
        selectionList: [],
        functionCode: 'productList',
        idKey: 'productCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
          productLevelCode: proxL,
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'id');
      this.productList = this.getReset(this.productList.concat(data), [], 'id');
      this.productList = this.productList.map((item) => ({
        productName: item.productName,
        productCode: item.productCode,
        productLevelCode: item.productLevelCode,
        productLevelName: item.productLevelName,
        specification: item.spec,
        unitConversion: item.ext35 || 0,
      }));
      this.$emit('input', this.productList);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },

  },
};
</script>

<style lang="less" scoped>
  .edit-table {
    padding-left: 50px;
    margin-left: 0 !important;
  }
</style>
